import { CommonModule } from '@angular/common';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Picker } from 'emoji-mart';

import { EmojisService } from '../../../services/emojis.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  selector: 'app-emoji-picker',
  templateUrl: './emoji-picker.component.html',
  styleUrls: ['./emoji-picker.component.scss'],
})
export class EmojiPickerComponent implements OnInit, AfterViewInit {
  callback: (emoji: any) => void;
  private picker: any;

  constructor(private emojisService: EmojisService) {}

  async ngOnInit() {
    const container = document.querySelector('#emoji-picker-container');
    if (!container) {
      console.error('Emoji picker container not found!');
      return;
    }

    await this.emojisService.loadEmojis();

    this.picker = new Picker({
      onEmojiSelect: (emoji: any) => {
        if (!this.callback) {
          return;
        }
        this.callback(emoji);
      },
      custom: [
        {
          id: 'custom',
          name: 'Custom',
          emojis: this.emojisService.customEmojis,
        },
      ],
      autoFocus: true,
    });

    document.querySelector('#emoji-picker-container').appendChild(this.picker);
  }

  ngAfterViewInit(): void {
    this.focusSearchInput();
  }

  private focusSearchInput(): void {
    // Add a small delay to allow popover animation/rendering to settle
    setTimeout(() => {
      requestAnimationFrame(() => {
        this.picker?.component?.refs?.searchInput?.current?.focus();
      });
    }, 100);
  }
}
